import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import { hasUnlimitedVersion } from 'utils/hasUnlimitedVersion';

import { User } from 'types';

import MenuItem from './MenuItem';

type Props = {
  order: string;
  societyId: string;
  isActive: boolean;
};

const DraftMenu: FC<Props> = ({ order, societyId, isActive }) => {
  const { t } = useTranslate();

  return (
    <>
      <Accordion.Toggle as={Button} variant="link" eventKey={order}>
        <li className={`nk-menu-item has-sub ${isActive ? 'active' : ''}`}>
          <a className="nk-menu-link nk-menu-toggle">
            <span className="nk-menu-icon">
              <em className="icon ni ni-calc" />
            </span>
            <span className="nk-menu-text">{t('Drafts')}</span>
          </a>
        </li>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={order}>
        <ul className="nk-menu-sub">
          <MenuItem
            linkTo={`/borradores/${societyId}`}
            text="DraftsList"
            disabled={!hasUnlimitedVersion()}
          />

          <MenuItem
            linkTo={`/borrador-ampliacion/${societyId}`}
            text="DraftCapitalIncrease"
            disabled={!hasUnlimitedVersion()}
          />

          <MenuItem
            linkTo={`/borrador-venta/${societyId}`}
            text="DraftSellShares"
            disabled={!hasUnlimitedVersion()}
          />

          <MenuItem
            linkTo={`/borrador-nota/${societyId}`}
            text="DraftConvertibleNote"
            disabled={!hasUnlimitedVersion()}
          />

          <MenuItem
            linkTo={`/borrador-compra-venta/${societyId}`}
            text="DraftSellParticipations"
            disabled={!hasUnlimitedVersion()}
          />

          <MenuItem
            linkTo={`/borrador-safe/${societyId}`}
            text="DraftSAFE"
            disabled={!hasUnlimitedVersion()}
          />
        </ul>
      </Accordion.Collapse>
    </>
  );
};

export default DraftMenu;
